"use strict";

/**
 * Define the output of this file. The output of CSS and JS file will be auto detected.
 *
 * @output js/scripts.bundle
 */

// Core Plugins
window.KTUtil = require("../js/global/components/base/util");
window.KTApp = require("../js/global/components/base/app");
window.KTAvatar = require("../js/global/components/base/avatar");
window.KTDialog = require("../js/global/components/base/dialog");
window.KTHeader = require("../js/global/components/base/header");
window.KTMenu = require("../js/global/components/base/menu");
window.KTOffcanvas = require("../js/global/components/base/offcanvas");
window.KTPortlet = require("../js/global/components/base/portlet");
window.KTScrolltop = require("../js/global/components/base/scrolltop");
window.KTToggle = require("../js/global/components/base/toggle");
window.KTWizard = require("../js/global/components/base/wizard");
require("../js/global/components/base/datatable/core.datatable");
require("../js/global/components/base/datatable/datatable.checkbox");
require("../js/global/components/base/datatable/datatable.rtl");

// Layout Scripts
window.KTLayout = require("../js/global/layout/layout");
window.KTChat = require("../js/global/layout/chat");
require("../js/global/layout/demo-panel");
require("../js/global/layout/offcanvas-panel");
require("../js/global/layout/quick-panel");
require("../js/global/layout/quick-search");
